// @ts-nocheck
import { getCurrentUser, logout } from "../auth/session";
import { openCommunityView } from "./posts-feed";
import { openProfile } from "./my-headstones";
import { showView } from "./view-router";
import { showOnboarding } from "./onboarding";

export function closeAccountMenuModal() {
  const modal = document.getElementById("account-menu-modal");
  if (modal) modal.style.display = "none";
}

export function openCommunityMemories() {
  closeAccountMenuModal();
  openCommunityView().catch(() => null);
}

export async function logoutCurrentUser() {
  await logout();
  closeAccountMenuModal();
  showView("garden");
  showOnboarding();
}

export async function onAccountButton() {
  const user = getCurrentUser();
  if (user) {
    openProfile().catch(() => null);
    return;
  }
  window.openAuthModal("login");
}
